class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(
        this.dataset.index,
        0,
        "remove"
      );
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        /***********************************************************
         * FREE SHIPPING AND FREE GIFT WITH PURCHASE
         * Updates text depending if cart total qualifies for free gift and/or free shipping
         * If cart total meets the free gift threshold and is not in cart, add the gift to cart
         ***/
        this.updatePromoText(parsedState);

        // console.log({parsedState});
        // console.log({name}, {line});
        const fgContainer = document.querySelector("[data-fg-threshold]");
        if (
          parsedState.total_price >=
            fgContainer.getAttribute("data-fg-threshold") &&
          name != "remove"
        ) {
          checkCartForGift(parsedState);
        }

        /* -------------------------------------------------------------------
         * Hide Klarna and Clearpay if any item in cart is a subscription item
         * -------------------------------------------------------------------
         */
        if (parsedState.items.some((item) => item.selling_plan_allocation !== null)) {
          document.querySelectorAll("klarna-placement", "afterpay-placement", "square-placement").classList.add("hidden");
        } else {
          document.querySelectorAll("klarna-placement", "afterpay-placement", "square-placement").classList.remove("hidden");
        }
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled");
  }

  /**
   * FREE GIFT WITH PURCHASE
   * Add a new line item to the cart
   * {number} id - The gift's variant id
   */
  addFreeItem(id, quantity) {
    var formData = {
      items: [
        {
          id: id,
          quantity: quantity,
        },
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    //delete config.headers['Content-Type'];
    config.method = "POST";
    config.body = JSON.stringify(formData);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        // document.getElementById('cartFreeGiftMessageWrapper').setAttribute('data-gift-added', true);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            response.sections[section.section],
            section.selector
          );
        });
      })
      .catch((e) => {
        console.log({ e });
        console.error(e);
      })
      .finally(() => {
        // this.submitButton.classList.remove('loading');
        // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        console.log("GIFT HAS BEEN ADDED");
      });
  }

  updatePromoText(cart) {
    let hasSubscriptionInCart = false,
      totalPrice = cart.total_price;

    const freeShippingTextEl = document.getElementById(
        "cartFreeShippingMessage"
      ),
      freeGiftTextEl = document.getElementById("cartFreeGiftMessage"),
      progressBarEl = document.querySelector("progress");

    if (
      (typeof freeShippingTextEl != "undefined" &&
        freeShippingTextEl != null) ||
      (typeof freeGiftTextEl != "undefined" && freeGiftTextEl != null)
    ) {
      setTimeout(() => {
        if (typeof freeGiftTextEl != "undefined" && freeGiftTextEl != null) {
          let cartContent = updateFreePromoMessage.checkCartContent(cart);
          freeGiftTextEl.innerHTML = updateFreePromoMessage.getGiftMessage(
            cartContent.cartTotalPrice,
            true
          );
        }

        if (
          typeof freeShippingTextEl != "undefined" &&
          freeShippingTextEl != null
        ) {
          document
            .querySelectorAll(".cart-item__details .product-option")
            .forEach((element, index) => {
              if (element.textContent.includes("Delivery every")) {
                hasSubscriptionInCart = true;
              }
            });

          let cartContent = updateFreePromoMessage.checkCartContent(cart);
          totalPrice = cartContent.cartTotalPrice;

          if (progressBarEl) {
            if (hasSubscriptionInCart) {
              totalPrice = parseFloat(
                document
                  .querySelector("[data-fs-threshold]")
                  .getAttribute("data-fs-threshold")
              );
            }
            progressBarEl.setAttribute("value", totalPrice);
          }

          freeShippingTextEl.innerHTML =
            updateFreePromoMessage.getShippingMessage(
              totalPrice,
              hasSubscriptionInCart
            );
        }
      }, 800);
    }
  }
}

customElements.define("cart-items", CartItems);

/* On cart page load, check if cart qualifies for a free gift
 * If cart total >= free gift threshold, add the gift if it isn't there yet
 */

if (
  typeof document.getElementById("cartFreeGiftMessageWrapper") != undefined &&
  document.getElementById("cartFreeGiftMessageWrapper") != null
) {
  const fgContainer = document.getElementById("cartFreeGiftMessageWrapper");
  if (fgContainer != null) {
    var freeGiftThreshold = parseFloat(
      document
        .querySelector("[data-fg-threshold]")
        .getAttribute("data-fg-threshold")
    );
    var freeGiftId = fgContainer.getAttribute("data-gift-id");
  }

  var checkCartForGift = function (cart) {
    // console.log("check cart for gift");
    // console.log({cart});
    let hasGiftId = false,
      cartTotalPrice = cart.total_price;

    cart.items.some(function (item, i) {
      if (item.id == freeGiftId && item.final_line_price === 0) {
        hasGiftId = true;
        cartTotalPrice = cart.total_price;
        return true;
      } else if (item.id == freeGiftId && item.final_line_price > 0) {
        hasGiftId = true;
        cartTotalPrice = cartTotalPrice - item.final_price;
      }
    });

    // console.log({hasGiftId}, "cartTotalPrice: "+(cartTotalPrice/100.00));

    if (!hasGiftId && cartTotalPrice >= freeGiftThreshold) {
      var fg = new CartItems();
      fg.addFreeItem(freeGiftId, 1);
    }
  };

  if (fgContainer != null) {
    Shopify.getCart(checkCartForGift);
  }
}
